// mutation常量，使用常量替代mutation事件类型
const SET_HEIHT = 'SET_HEIHT'
const SET_PRINTLABELS = 'SET_PRINTLABELS'
const SET_ORDERLIST = 'SET_ORDERLIST'
const SET_ORDERINFO = 'SET_ORDERINFO'
const SET_LANGUAGE = 'SET_LANGUAGE'
export {
  SET_HEIHT,
  SET_PRINTLABELS,
  SET_ORDERLIST,
  SET_ORDERINFO,
  SET_LANGUAGE
}



// WEBPACK FOOTER //
// ./src/store/mutations-type.js